/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Recommends,
    RecommendsFromJSON,
} from '../models';

/**
 *
 */
export class RecommendsApi extends runtime.BaseAPI {

    /**
     * Get Recommends
     */
    async getRecommendsApiRecommendsGetRaw(): Promise<runtime.ApiResponse<Recommends>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/recommends`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RecommendsFromJSON(jsonValue));
    }

    /**
     * Get Recommends
     */
    async getRecommendsApiRecommendsGet(): Promise<Recommends> {
        const response = await this.getRecommendsApiRecommendsGetRaw();
        return await response.value();
    }

}
